import React, { Fragment, useEffect, useState } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { FormSelect } from 'components/form/FormSelect';
import { useQuery } from 'libs/react';
import { useUser } from 'components/user/UserProvider';
import { gql } from '@apollo/client';
import './DealReassignModal.scss';
/**
 * @component DealReassignModal
 * @since 1.0.0
 * @hidden
 */
export function DealReassignModal(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { onClose, onConfirm, deal } = props;
    const user = useUser();
    const [dealUserId, setDealUser] = useState((_b = (_a = deal === null || deal === void 0 ? void 0 : deal.user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '');
    const [dealPartnerId, setDealPartner] = useState((_d = (_c = deal === null || deal === void 0 ? void 0 : deal.partner) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null);
    const [dealPartnerContactId, setDealPartnerContact] = useState((_f = (_e = deal === null || deal === void 0 ? void 0 : deal.partnerContact) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : null);
    let users = [];
    const [usersData] = useQuery(gql `
      query UserListQuery($input: UsersInput!) {
        users(input: $input) {
          items {
            id
            fullname
            email
          }
        }
      }
    `, {
        variables: {
            input: {
                isInternalUser: true
            }
        },
        skip: user.isContactUser() && user.isManager()
    });
    users = (_g = usersData === null || usersData === void 0 ? void 0 : usersData.users.items) !== null && _g !== void 0 ? _g : [];
    let representatives = [];
    const [contactsData] = useQuery(gql `
      query ContactListQuery($input: ContactsInput!) {
        contacts(input: $input) {
          items {
            id
            firstname
            lastname

            user {
              id
              email
            }

            client {
              id
              name
            }
          }
        }
      }
    `, {
        variables: {
            input: {
                isEndClient: false,
                hasUser: true
            }
        },
        skip: user.isContactUser() && !user.isManager()
    });
    representatives = (_h = contactsData === null || contactsData === void 0 ? void 0 : contactsData.contacts.items) !== null && _h !== void 0 ? _h : [];
    const options = users.length > 0
        ? users === null || users === void 0 ? void 0 : users.map((user) => ({
            value: user.id,
            label: user.fullname + ' (' + user.email + ')'
        }))
        : [];
    const contactsOptions = representatives.length > 0
        ? representatives.map((contact) => {
            var _a, _b;
            return ({
                value: contact.id,
                label: contact.firstname +
                    ' ' +
                    contact.lastname +
                    ' (' +
                    ((_a = contact.user) === null || _a === void 0 ? void 0 : _a.email) +
                    ')' +
                    ' - ' +
                    ((_b = contact.client) === null || _b === void 0 ? void 0 : _b.name)
            });
        })
        : [];
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    const onChange = (type, value) => {
        if (type === 'internal') {
            setDealUser(value);
            setDealPartner(null);
            setDealPartnerContact(null);
        }
        else {
            representatives.find((contact) => {
                var _a, _b, _c, _d;
                if (contact.id === value) {
                    setDealUser((_b = (_a = contact.user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '');
                    setDealPartner((_d = (_c = contact.client) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '');
                    setDealPartnerContact(contact.id);
                }
            });
        }
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (deal) {
            setDealUser((_b = (_a = deal.user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '');
            setDealPartner((_d = (_c = deal.partner) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '');
            setDealPartnerContact((_f = (_e = deal.partnerContact) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : '');
        }
    }, [deal]);
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement("div", { className: "deal-reassign-modal-button-container" },
            React.createElement(Button, { style: "primary", label: t('Apply'), onPress: () => onConfirm(dealUserId, dealPartnerId, dealPartnerContactId) }))));
    return (React.createElement("div", { className: "deal-reassign-modal" },
        React.createElement(Modal, { picto: "pencil", title: t('Reassign Quote'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-reassign-modal-content" },
                !user.isContactUser() && !user.isManager() && (React.createElement(FormSelect, { placeholder: t('Search or Select user'), name: "assignTo", label: t('Assign quote to an internal user'), options: options, onChange: (value) => {
                        onChange('internal', value);
                    }, search: true, className: "deal-reassign-modal-select" })),
                React.createElement(FormSelect, { placeholder: t('Search or Select user'), name: "assignTo", label: t('Assign quote to a partner user'), options: contactsOptions, onChange: (value) => {
                        onChange('partner', value);
                    }, search: true, className: "deal-reassign-modal-select" })))));
}
